import IndexPage from './online';

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js